var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlaybooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ppogfw2yaa",
    d: "M17.09 4c1.55 0 2.817 1.211 2.905 2.738L20 6.91v10.182c0 1.55-1.211 2.816-2.738 2.904L17.09 20H6.909c-1.55 0-2.816-1.211-2.904-2.738L4 17.09V6.909c0-1.55 1.211-2.816 2.738-2.904L6.91 4h10.182zm0 2H6.91c-.467 0-.851.35-.904.803L6 6.91v10.182c0 .466.35.85.803.903L6.91 18h10.182c.466 0 .85-.35.903-.803L18 17.09V6.909c0-.466-.35-.85-.803-.903L17.09 6zM22 6c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1s-1-.448-1-1V7c0-.552.448-1 1-1zM2 6c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1s-1-.448-1-1V7c0-.552.448-1 1-1zm8.357 3l4.286 3-4.286 3V9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "ijsi0t4asb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ppogfw2yaa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.87,
    mask: "url(#ijsi0t4asb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaybooks);
export default __webpack_public_path__ + "static/media/icon-playbooks.feea9da1a7983649fb92c3babc5d62d2.svg";
export { ForwardRef as ReactComponent };